// tslint:disable: variable-name
export enum StepType {
  PersonalDetails = 1,
  TermsAndConditions = 2,
  PartnerInvite = 3,
  ResetPassword = 5,
  LoginDetails = 7,
  PartnerCardPrint = 11,
  SocialLink = 16,
  SocialMediaCustomerIdentification = 17,
  CheckGuardianMembership = 18,
  GuardianQuestions = 19,
  AddChild = 20,
  GuardianDetails = 22,
  ProcessPartnerRequest = 23,
  LoginDetailsEdit = 24,
  ValidateMemberIdAndCardNumber = 25,
  ReferAFriend = 26,
  AgeVerificationAndTerms = 27,
  OptOutEmails = 33,
  PartnerManagementRemoveOrKeep = 36,
  OptOutAlerts = 37,
  ProviderTranslation = 39,
  ProviderAuthentication2 = 41,
  Questions = 44,
  ChildQuestions = 45,
  Payment = 46,
  Basket = 48,
  MembershipOption = 50,
  GetProviderDetails = 51,
  ShippingAddress = 52,
  OperatorName = 54,
  ChooseMembershipOption = 55,
  ProviderOAuth = 56,
  Marketing = 57,
  SelectCustomerMembershipOption = 60,
  BenefitOptions = 61,
  AccountVerify = 62,
}
